import { watchOnce } from '@vueuse/core';
import { useNavPreferred } from '~/stores/navPreferred';
import { storeToRefs } from 'pinia';

export default function onPreferredStoreReady(cb) {
  const store = useNavPreferred();
  const { initialized } = storeToRefs(store);

  if (initialized.value) {
    cb();
    return;
  }

  watchOnce(initialized, cb);
}
